// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AccountTradeStatus;
(function (AccountTradeStatus) {
    AccountTradeStatus[AccountTradeStatus["ACTIVE_STATUS"] = 0] = "ACTIVE_STATUS";
    AccountTradeStatus[AccountTradeStatus["CLOSED_STATUS"] = 1] = "CLOSED_STATUS";
    AccountTradeStatus[AccountTradeStatus["SUSPEND_STATUS"] = 2] = "SUSPEND_STATUS";
    AccountTradeStatus[AccountTradeStatus["TRADING_DISABLED_RISK_STATUS"] = 3] = "TRADING_DISABLED_RISK_STATUS";
    AccountTradeStatus[AccountTradeStatus["FINRA_DAY_TRADER_PATTERN_STATUS"] = 4] = "FINRA_DAY_TRADER_PATTERN_STATUS";
    AccountTradeStatus[AccountTradeStatus["LIQUIDATION_ONLY_STATUS"] = 5] = "LIQUIDATION_ONLY_STATUS";
})(AccountTradeStatus || (AccountTradeStatus = {}));
